/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import Routes from "./routes";
import { URL_BEGINNING } from "./config";
import { AuthConsumer } from "./AuthContext"; // Import AuthConsumer

/* Intercom */
import { IntercomProvider } from "react-use-intercom";

class App extends Component {
  // Renamed component to App for clarity
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    let url = window.location.href;
    if (url.includes("www")) {
      const checkStr = /^(?:https?:\/\/)?(?:www\.)?/i;
      url = window.location.href.replace(checkStr, "");
      window.location.href = URL_BEGINNING + url;
      this.setState({
        loading: false,
      });
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  render() {
    if (this.state.loading) {
      return <div>loading</div>;
    }
    const INTERCOM_APP_ID = "npbpd76v";

    return (
      <AuthConsumer>
        {(
          { appPlatform }, // Consume appPlatform
        ) => (
          <div className={`app-container ${appPlatform}`}>
            {" "}
            {/* Add dynamic class */}
            {/* Optional: Display platform for debugging */}
            {/* <h1 style={{ position: 'fixed', top: 0, left: 0, background: 'rgba(255,255,255,0.8)', zIndex: 9999 }}>
              Context: {appContext}
            </h1> */}
            <IntercomProvider appId={INTERCOM_APP_ID}>
              <Routes />
            </IntercomProvider>
          </div>
        )}
      </AuthConsumer>
    );
  }
}

export default App; // Export with the new name
